module.exports = __webpack_public_path__ + "static/media/brainAI.38495033.svg";